import { RecordPayload } from '../../models/payload/recordpayload.class';
import { createAction, props } from '@ngrx/store';

import { Entity } from '../../models/entity.class';

enum CustomActionTypes {
    SAMPLE_ACTION = '[Custom] Get Description',
    SET_INSTANCE_ID = '[Custom] Set Instance ID',
    SET_APP_REST_API_NAME = '[Custom] Set App Rest Api Name',
    SET_APP_SERVICE_ID = '[Custom] Set App Service Id',
    SET_INSTANCES_PAGINATION = '[Custom] Set Instances Pagination',
    GET_INSTANCES = '[Custom] Get Instances',
    CLEAR_INSTANCES = '[Custom] Clear Instances',
    CANCEL_PROCESS_INSTANCE = '[Custom] Cancel Process Instance',
    GET_PRE_CAPTURED_ATTRIBUTES = '[Custom] Get Pre Captured Attributes',
    SET_PRE_CAPTURED_ATTRIBUTES = '[Custom] Set Pre Captured Attributes',
    GET_INTEGRATION_STATUS = '[Custom] Get Integration Status',
    RETRY_INTEGRATION_STATUS = '[Custom] Retry Integration Status',
    GET_INSTANCE_REPORTS = '[Custom] Get Instance Reports',
    GENERATE_INSTANCE_REPORT = '[Custom] Generate Instance Report',
    GET_INSTANCE_EVENT_TYPES = '[Custom] Get Instance Event Types',
    GET_INSTANCE_TRANSFORMATIONS = '[Custom] Get Instance Transformations',
    GET_INSTANCE_DOWNLOADABLE_FILES = '[Custom] Get Instance Downloadable Files',
    CLEAR_DOWNLOADABLE_FILES = '[Custom] Clear Downloadable Files',
    GET_INSTANCE_COLLABORATORS = '[Custom] Get Instance Collaborators',
    GET_SERVICE_TRANSFORMATIONS = '[Custom] Get Service Transformations',
    CREATE_SERVICE_BULK_REPORTS_DOWNLOAD_REQUEST = '[Custom] Create Service Bulk Reports Download Request',
    GET_CUSTOM_APP_METADATA = '[Custom] Get Custom App Metadata',
    GET_CUSTOM_APP_METADATA_PERMISSIONS = '[Custom] Get Custom App Metadata Permissions',
    GET_CUSTOM_APP_PERMISSIONS = '[Custom] Get Custom App Permissions',
    SET_CUSTOM_SELECTED_ENTITY_UID = '[Custom] Set Custom Selected Entity UId',
    SET_CUSTOM_SELECTED_ENTITY_PARENT_RECORD_ID = '[Custom] Set Custom Selected Entity Parent Record Id',
    GET_CUSTOM_AUDIT_CHANGED_ENTITIES = '[Custom] Get Custom Audit Changed Entities',
    SET_CUSTOM_ENTITY_RECORDS_PAGINATION = '[Custom] Set Custom Entity Records Pagination',
    CLEAR_CUSTOM_ENTITY_RECORDS_PAGINATION = '[Custom] Clear Custom Entity Records Pagination',
    SET_CUSTOM_ENTITY_RECORDS_SEARCH_CRITERIA = '[Custom] Set Custom Entity Records Search Criteria',
    GET_CUSTOM_ENTITY_RECORDS = '[Custom] Get Custom Entity Records',
    GET_CUSTOM_APP_WORKFLOW = '[Custom] Get Custom App Workflow',
    VALIDATE_CUSTOM_ENTITY_RECORD_DATA = '[Custom] Validate Custom Entity Record Data',
    SAVE_OR_UPDATE_CUSTOM_ENTITY_RECORD = '[Custom] Save or Update Custom Entity Record',
    UPDATE_CUSTOM_ENTITY_RECORDS = '[Custom] Update Custom Entity Records',
    DELETE_CUSTOM_ENTITY_RECORDS = '[Custom] Delete Custom Entity Records',
    GET_CUSTOM_ENTITY_RECORD_CHANGE_LOGS = '[Custom] Get Custom Entity Record Change Logs',
}

export const SampleAction = createAction(CustomActionTypes.SAMPLE_ACTION);

export const SetCustomInstanceId = createAction(
    CustomActionTypes.SET_INSTANCE_ID,
    props<{
        instanceId: string;
    }>()
);

export const SetCustomAppsRestApiName = createAction(
    CustomActionTypes.SET_APP_REST_API_NAME,
    props<{
        appRestApiName: string;
        bridgeRestApiName: string;
    }>()
);

export const SetCustomAppServiceId = createAction(
    CustomActionTypes.SET_APP_SERVICE_ID,
    props<{
        appServiceId: string;
    }>()
);

export const SetProcessInstancesPagination = createAction(
    CustomActionTypes.SET_INSTANCES_PAGINATION,
    props<{
        pagination: {
            size: number;
            pageIndex: number;
            pagingState: any;
        };
    }>()
);

export const GetProcessInstances = createAction(CustomActionTypes.GET_INSTANCES, props<{ noAlerts?: boolean }>());

export const ClearProcessInstances = createAction(CustomActionTypes.CLEAR_INSTANCES);

export const CancelProcessInstance = createAction(
    CustomActionTypes.CANCEL_PROCESS_INSTANCE,
    props<{
        instanceId: string;
        comment: string;
        restApiName?: string;
    }>()
);

export const GetPreCapturedAttributes = createAction(CustomActionTypes.GET_PRE_CAPTURED_ATTRIBUTES, props<{ instanceId?: string }>());

export const SetPreCapturedAttributes = createAction(CustomActionTypes.SET_PRE_CAPTURED_ATTRIBUTES);

export const GetIntegrationStatus = createAction(
    CustomActionTypes.GET_INTEGRATION_STATUS,
    props<{
        instanceId?: string;
        noAlerts?: boolean;
    }>()
);

export const RetryIntegrationStatus = createAction(
    CustomActionTypes.RETRY_INTEGRATION_STATUS,
    props<{
        requestId: string;
        unitId: string;
        assetId: string;
        bridgeId: string;
        serviceId: string;
        assetDataId: string;
        userId: string;
        requestLevel: boolean;
        noAlerts?: boolean;
    }>()
);

export const GetInstanceReports = createAction(
    CustomActionTypes.GET_INSTANCE_REPORTS,
    props<{
        instanceId: string;
        noAlerts?: boolean;
        forceFetch?: boolean;
    }>()
);

export const GenerateInstanceReport = createAction(
    CustomActionTypes.GENERATE_INSTANCE_REPORT,
    props<{
        instanceId: string;
        chainName: string;
        noAlerts?: boolean;
    }>()
);

export const GetInstanceEventTypes = createAction(CustomActionTypes.GET_INSTANCE_EVENT_TYPES);

export const GetInstanceTransformations = createAction(
    CustomActionTypes.GET_INSTANCE_TRANSFORMATIONS,
    props<{
        instanceId: string;
        assetUid: string;
    }>()
);

export const GetInstanceDownloadableFiles = createAction(
    CustomActionTypes.GET_INSTANCE_DOWNLOADABLE_FILES,
    props<{
        instanceId: string;
    }>()
);

export const ClearDownloadableFiles = createAction(
    CustomActionTypes.CLEAR_DOWNLOADABLE_FILES,
    props<{
        instanceId: string;
    }>()
);

export const GetInstanceCollaborators = createAction(
    CustomActionTypes.GET_INSTANCE_COLLABORATORS,
    props<{
        instanceId: string;
        assetId: string;
        noAlerts?: boolean;
    }>()
);

export const GetServiceTransformations = createAction(
    CustomActionTypes.GET_SERVICE_TRANSFORMATIONS,
    props<{ serviceId: string; restApiName?: string; noAlerts?: boolean; forceFetch?: boolean }>()
);

export const CreateServiceBulkReportsDownloadRequest = createAction(
    CustomActionTypes.CREATE_SERVICE_BULK_REPORTS_DOWNLOAD_REQUEST,
    props<{ serviceId: string; transformationNames: string[]; instanceIds?: string[] }>()
);

export const GetCustomAppMetaData = createAction(CustomActionTypes.GET_CUSTOM_APP_METADATA);

export const GetCustomAppMetaDataPermissions = createAction(CustomActionTypes.GET_CUSTOM_APP_METADATA_PERMISSIONS);

export const GetCustomAppPermissions = createAction(CustomActionTypes.GET_CUSTOM_APP_PERMISSIONS);

export const SetCustomSelectedEntityUId = createAction(
    CustomActionTypes.SET_CUSTOM_SELECTED_ENTITY_UID,
    props<{
        selectedEntityUId: string;
    }>()
);

export const SetCustomSelectedEntityParentRecordId = createAction(
    CustomActionTypes.SET_CUSTOM_SELECTED_ENTITY_PARENT_RECORD_ID,
    props<{
        selectedEntityParentRecordId: string;
    }>()
);

export const GetCustomAuditChangedEntities = createAction(
    CustomActionTypes.GET_CUSTOM_AUDIT_CHANGED_ENTITIES,
    props<{
        parentRecordId: string;
        timeStamp: any;
    }>()
);

export const ClearCustomEntityRecordsPagination = createAction(CustomActionTypes.CLEAR_CUSTOM_ENTITY_RECORDS_PAGINATION);

export const SetCustomEntityRecordsPagination = createAction(
    CustomActionTypes.SET_CUSTOM_ENTITY_RECORDS_PAGINATION,
    props<{
        serviceId: string;
        instanceId: string;
        entityUId: string;
        parentRecordId: string;
        size: number;
        pageIndex: number;
        pagingState?: any;
        noAlerts?: boolean;
    }>()
);

export const SetCustomEntityRecordsSearchCriteria = createAction(
    CustomActionTypes.SET_CUSTOM_ENTITY_RECORDS_SEARCH_CRITERIA,
    props<{
        organizationId?: string;
        serviceId?: string;
        instanceId?: string;
        entityUId?: string;
        parentRecordId?: string;
        searchCriteria: any;
        noAlerts?: boolean;
    }>()
);

export const GetCustomAppWorkflow = createAction(CustomActionTypes.GET_CUSTOM_APP_WORKFLOW);

export const ValidateCustomEntityRecordData = createAction(
    CustomActionTypes.VALIDATE_CUSTOM_ENTITY_RECORD_DATA,
    props<{
        record: any;
        restAPIName: string;
        entityId: string;
        entities: any;
        configurations: any;
        process?: string;
        inSearch?: boolean;
    }>()
);

export const SaveOrUpdateCustomEntityRecord = createAction(
    CustomActionTypes.SAVE_OR_UPDATE_CUSTOM_ENTITY_RECORD,
    props<{
        serviceId?: string;
        restAPIName?: string;
        instanceId?: string;
        parentRecordId?: string;
        entityUId?: string;
        entities: Entity[];
        record: any;
        isArray: boolean;
        configurations: any;
        process?: string;
        noAlerts?: boolean;
    }>()
);

export const UpdateCustomEntityRecords = createAction(
    CustomActionTypes.UPDATE_CUSTOM_ENTITY_RECORDS,
    props<{
        serviceId?: string;
        restAPIName?: string;
        instanceId?: string;
        parentRecordId?: string;
        entityUId?: string;
        recordsPayload: RecordPayload[];
        noAlerts?: boolean;
        noMessages?: boolean;
    }>()
);

export const DeleteCustomEntityRecords = createAction(
    CustomActionTypes.DELETE_CUSTOM_ENTITY_RECORDS,
    props<{
        serviceId: string;
        instanceId: string;
        entityId: string;
        parentRecordId?: string;
        payload: { id: string; parentRecordId: string }[];
        noAlerts?: boolean;
        noMessages?: boolean;
        deleteFromSource?: boolean;
        reconSpecific?: boolean;
    }>()
);

export const GetCustomEntityRecordChangeLogs = createAction(
    CustomActionTypes.GET_CUSTOM_ENTITY_RECORD_CHANGE_LOGS,
    props<{
        assetId?: string;
        instanceId?: string;
        parentRecordId?: string;
        entityUId?: string;
        recordId?: string;
    }>()
);
